import React from 'react';
import PropTypes from 'prop-types';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip} from '@mui/material';
import {ezprOrange} from '../_helpers';
import {LoadingButton} from '@mui/lab';

/**
 * @param {GenericPopup.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function GenericPopup(props) {
    const handleClose = () => {
        props.onClose();
    };

    return (
        <Dialog
            onClose={(event, reason) => {
                if (props.disableBackdropClose && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
                    return;
                }
                handleClose();
            }}
            open={props.open}
            aria-labelledby="generic-popup-title"
            style={{flexDirection: 'row'}}
        >
            <div style={{display: 'flex'}}>
                <div style={{backgroundColor: props.color, width: '20%', height: 'auto', display: 'flex', alignItems: 'center', minWidth: '50px', justifyContent: 'center'}}>
                    <i className="material-icons" style={{color: 'white'}}>{props.icon}</i>
                </div>
                <div>
                    <DialogTitle id="popup-title">{props.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="popup-description">
                            {props.text}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {props.buttons.map((o) => {
                            return (
                                <Tooltip title={o.tooltipText} placement={'top'} key={'genericPopupBtn' + o.tooltipText}>
                                    <LoadingButton
                                        key={'genericPopupBtn' + o.text}
                                        onClick={o.handleFunction}
                                        variant={o.highlighted ? 'outlined' : 'text'}
                                        sx={o.highlighted ? {color: ezprOrange, borderColor: `${ezprOrange} !important`} : {}}
                                        loading={o.loading}
                                    >
                                        {o.text}
                                    </LoadingButton>
                                </Tooltip>
                            );
                        })}
                    </DialogActions>
                </div>
            </div>

        </Dialog>
    );
}

GenericPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    title: PropTypes.string,
    text: PropTypes.node,
    icon: PropTypes.string,
    color: PropTypes.string,
    buttons: PropTypes.arrayOf(PropTypes.shape({
        handleFunction: PropTypes.func,
        text: PropTypes.string,
        highlighted: PropTypes.bool,
        tooltipText: PropTypes.string,
        loading: PropTypes.bool,
    })),
    disableBackdropClose: PropTypes.bool,
};
